// extracted by mini-css-extract-plugin
export default {"wrapper":"AccountPane_wrapper__pWfwV","info":"AccountPane_info__Cpy2k","preferences":"AccountPane_preferences__C2VRm"};